export default __webpack_public_path__ + "static/media/cashier.6d5fcb04.jpg";